import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { UserService } from '../../services/Users.service';
import { CustomerRole } from '../../models/CustomerRole';
import { PermissionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Permissions.service';
import { RoleService } from 'src/app/features/roles/services/Role.service';

@Component({
  selector: 'customer-control',
  templateUrl: './customer-control.component.html',
  styleUrls: ['./customer-control.component.css']
})
export class CustomerControlComponent {
  public formGroup: FormGroup;
  
  @Input() clientNumber: number;

  @Output() public customerData = new EventEmitter<any>();
  @Output() public deleteCustomer = new EventEmitter<any>();

  public otherCustomers: {
    selected: boolean,
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[];
  public $otherCustomers: Observable<any>;
  public $updateOtherCustomers: Observable<any>;

  customers: string[];
  roles : string[];
  groups : string[];
  subGroups : string[];
  _stringIdentifiers: string ="";
  _vinIdentifiers: string ="";
  filtersList: any;
  isDirectAssign : boolean = false;

  clientToUnselect: string = "";
  selectedClient: {
    selected: boolean,
    number: number, 
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  };

  subscription_getListRoles: Subscription;
  subscription_getListPermissions: Subscription;
  suscription_updateOtherCustomers: Subscription;
  suscription_OtherCustomers: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private permissionService: PermissionsService,
    private roleService: RoleService
  ) { 
    
  }

  ngOnInit(): void {
    this.bulidForm();
    this.getData();
  }

  ngOnDestroy() {

      if (this.otherCustomers != undefined ) {
        const selected = this.otherCustomers.find(x => x.customerName == this.formGroup.controls["client"].value);
        console.log("otherCustomers destroy",selected, this.formGroup.controls["client"].value, this.otherCustomers);
        
        if (selected != undefined){
          selected.selected = false;
        
        if (this.selectedClient != undefined && this.userService.updateOtherCustomers != undefined && this.userService.updateOtherCustomers.length > 0) {
          this.userService.updateOtherCustomers.splice(this.userService.updateOtherCustomers.findIndex(x => x.number == this.clientNumber), 1);
        }
          console.log("otherCustomers destroy",this.otherCustomers);
          
          this.userService.setOtherCustomers(this.otherCustomers);
        }
      }
      if (this.selectedClient != undefined)
        this.sendEmptyData();

      if (this.subscription_getListRoles)
        this.subscription_getListRoles.unsubscribe();
      if (this.subscription_getListPermissions)
        this.subscription_getListPermissions.unsubscribe();
      if (this.suscription_updateOtherCustomers)
        this.suscription_updateOtherCustomers.unsubscribe();
      if (this.suscription_OtherCustomers)
        this.suscription_OtherCustomers.unsubscribe();
  }

  getData(){
    //get data se divide en dos partes, la primera es para cuando se crea el componente después de haber cargado a los clientes y ya no se actualiza el servicio, 
    //la segunda es para cuando se crea el componente y se está actualizando el servicio, por lo que se debe estar vigilando los cambios en el padre

    if (this.userService.isUpdateUser) {
      //esta zona solo se inicia cuando se está actyalizando un usuario y se necesitan obtener los datos de un cliente que viene desde la base
      //parte 1, se obtienen los datos del servicio y se actualiza el formulario cuando ya se han cargado los clientes en el servicio y no hay cambios
      if (this.userService.updateOtherCustomers != undefined && this.userService.updateOtherCustomers.length > 0) {
        this.selectedClient = this.userService.updateOtherCustomers.find(x => x.number == this.clientNumber);
        if (this.selectedClient != undefined) {
          this.formGroup.controls["client"].patchValue(this.selectedClient.customerName);
          this.formGroup.controls["groups"].patchValue(this.selectedClient.groups);
          this.formGroup.controls["subGroups"].patchValue(this.selectedClient.subGroups);
          
          this.formGroup.controls["rol"].patchValue(this.selectedClient.roles[0].roleName);
          if(this.subscription_getListPermissions)
            this.subscription_getListPermissions.unsubscribe();
          this.subscription_getListPermissions = this.permissionService.GetList(this.formGroup.controls["rol"].value).subscribe((data) => {
            console.log(data);
            if (data.isSuccess) {
              var asignacionPermiso = data.result.filter((x) => x.shortName == 'AsignacionDirecta');
              if (asignacionPermiso.length > 0) {
                this.isDirectAssign = true;
                this._vinIdentifiers = this.selectedClient.identifiers.join(",");
                this.formGroup.controls["identifiers"].patchValue(this.selectedClient.identifiers.join(",")); 
                this.setDirectAssign();
              }else{
                this.isDirectAssign = false;
                this.selectedClient.identifiers = [];
                this.filtersList = {};
              }
              console.log("direct assign", this.isDirectAssign);
              
            }else{
              console.log(data.message);
            }
          });

          console.log("selectedClient heeeeeeelp1   " + this.clientNumber,this.selectedClient);
          
          this.customerData.emit(this.selectedClient);
        }
      }

      //parte 2, se vigilan los datos del servicio y se actualiza el formulario cuando haya cambios
      this.$updateOtherCustomers = this.userService.getUpdateOtherCustomers();
      this.suscription_updateOtherCustomers = this.$updateOtherCustomers.subscribe((data) => {
        console.log("Update data "+ this.clientNumber,data);
        
        if (data != undefined && data.length > 0) {
          //se obtienen los datos del cliente seleccionado del padre y se actualiza el formulario
          this.selectedClient = data.find(x => x.number == this.clientNumber);
          
          this.formGroup.controls["client"].patchValue(this.selectedClient.customerName);
          this.formGroup.controls["groups"].patchValue(this.selectedClient.groups);
          this.formGroup.controls["subGroups"].patchValue(this.selectedClient.subGroups);

          this.formGroup.controls["rol"].patchValue(this.selectedClient.roles[0].roleName);
          if(this.subscription_getListPermissions)
            this.subscription_getListPermissions.unsubscribe();
          this.subscription_getListPermissions = this.permissionService.GetList(this.formGroup.controls["rol"].value).subscribe((data) => {
            console.log(data);
            if (data.isSuccess) {
              var asignacionPermiso = data.result.filter((x) => x.shortName == 'AsignacionDirecta');
              if (asignacionPermiso.length > 0) {
                this.isDirectAssign = true;
                this._vinIdentifiers = this.selectedClient.identifiers.join(",");
                this.formGroup.controls["identifiers"].patchValue(this.selectedClient.identifiers.join(",")); 
                this.setDirectAssign();
              }else{
                this.isDirectAssign = false;
                this.selectedClient.identifiers = [];
                this.filtersList = {};
              }
            }else{
              console.log(data.message);
            }
          });
          
          this.customerData.emit(this.selectedClient);
        }
      });
      
      console.log("selectedClient heeeeeeelp 2    " + this.clientNumber,this.selectedClient);
    }
    
    //esta zona es general y se inicia siempre. Trae los datos de todos los clientes y se actualizan los combo boxes

    //Parte 1, se añaden los nombres de clientes si se crea el componente después de haber cargado a los clientes la primera vez
    this.otherCustomers = this.userService.otherCustomers;
    if (this.otherCustomers != undefined){
      this.customers = this.otherCustomers.filter(c => !c.selected).map(client => client.customerName);
      if (this.formGroup.controls["client"].value != null && this.formGroup.controls["client"].value != "") {
        this.customers.push(this.formGroup.controls["client"].value); 
        const selectedClient = this.otherCustomers.find(x => x.customerName == this.formGroup.controls["client"].value);
        this.roles = selectedClient.roles.map((x) => x.roleName);
        this.groups = selectedClient.groups;
        this.subGroups = selectedClient.subGroups;

        if (this.formGroup.controls["subGroups"].value.length == 0)
          this.formGroup.controls["subGroups"].patchValue(["Vacio"]);
        if (this.formGroup.controls["groups"].value.length == 0)
          this.formGroup.controls["groups"].patchValue([""]);
      }
    }

    //Parte 2, va a estar vigilando los cambios en el servicio para actualizar los clientes seleccionables
    this.$otherCustomers = this.userService.getOtherCustomers();
    this.suscription_OtherCustomers = this.$otherCustomers.subscribe((data) => {
      this.otherCustomers = data;
      //cambia los clientes seleccionables para evitar duplicados
      this.customers = this.otherCustomers.filter(c => !c.selected).map(client => client.customerName);
      if (this.formGroup.controls["client"].value != null && this.formGroup.controls["client"].value != "") {
        this.customers.push(this.formGroup.controls["client"].value); 
      }

      //si se está actualizando un usuario, se llenan los combo boxes del cliente seleccionado
      if (this.formGroup.controls["client"].value != null && this.formGroup.controls["client"].value != "") {
        const selectedClient = data.find(x => x.customerName == this.formGroup.controls["client"].value);

        this.roles = selectedClient.roles.map((x) => x.roleName);
        this.groups = selectedClient.groups;
        this.subGroups = selectedClient.subGroups;

        if (this.formGroup.controls["subGroups"].value.length == 0)
          this.formGroup.controls["subGroups"].patchValue(["Vacio"]);
        if (this.formGroup.controls["groups"].value.length == 0)
          this.formGroup.controls["groups"].patchValue([""]);
      }
    });

  }

  bulidForm() {
    this.formGroup = this.formBuilder.group({
      client: ["", Validators.required],
      rol: ["", Validators.required],
      identifiers: [],
      groups: [[]],
      subGroups: [["Vacio"]],
    }, {});
  }

  onChangeClient(){
    
    // si ya había un cliente seleccionado, se libera para el resto de componentes
    if (this.clientToUnselect != "")
      this.otherCustomers.find(x => x.customerName == this.clientToUnselect).selected = false;

    // se obtienen los datos del cliente seleccionado del padre
    var selectedClient = this.otherCustomers.find(x => x.customerName == this.formGroup.controls["client"].value);
    
    // se actualizan los datos del cliente seleccionado en el padre
    this.clientToUnselect = this.formGroup.controls["client"].value;
    this.customers = this.otherCustomers.filter(client => !client.selected).map(client => client.customerName);
    selectedClient.selected = true;
    this.roles = selectedClient.roles.map((x) => x.roleName);
    this.groups = selectedClient.groups;
    this.subGroups = selectedClient.subGroups;
    this.userService.setOtherCustomers(this.otherCustomers);

    //se resetea el formulario y se envía vació al padre si se había seleccionado un cliente antes
    if (selectedClient.selected && this.selectedClient != undefined) {
      this.sendEmptyData();
    }
  }

  updateIdentifiers(stringIdentifiers: string) {
    console.log("stringIdentifiers",stringIdentifiers);
    
    this._stringIdentifiers = stringIdentifiers;
    
    this.sendCustomerData();
  }

  onChangeRole(obj: any){
    if(this.subscription_getListPermissions)
        this.subscription_getListPermissions.unsubscribe();
      this.subscription_getListPermissions = this.permissionService.GetList(obj.value).subscribe((data) => {
      console.log(data);
      if (data.isSuccess) {
        var asignacionPermiso = data.result.filter((x) => x.shortName == 'AsignacionDirecta');
        if (asignacionPermiso.length > 0) {
          this.isDirectAssign = true;
          this.setDirectAssign();
        }else{
          this.isDirectAssign = false;
          this.filtersList = {};
        }
      }else{
        console.log(data.message);
      }
      this.sendCustomerData();
    });
  }

  onChangeGroupOptions(option: any){
    if (option.value.length == 0) {
      this.formGroup.controls["groups"].patchValue([""]);
      option.value = [""];
    } else {
      if (option.value.includes("") && option.value.length > 1) {
        var selectedGroups = this.formGroup.controls["groups"].value;
        selectedGroups.splice(selectedGroups.indexOf(""),1);
        this.formGroup.controls["groups"].patchValue(selectedGroups);
        console.log("group option todos primero seleccionado", option.value, selectedGroups);
      }
    }
    this.setDirectAssign();
    this.sendCustomerData();
  }

  resetGroups(){
    this.formGroup.controls["groups"].patchValue([""]);
    this.setDirectAssign();
    this.sendCustomerData();
  }

  onChangeSubGroupOptions(option: any){
    if (option.value.length == 0) {
      this.formGroup.controls["subGroups"].patchValue([""]);
      option.value = [""];
    } else {
      if (option.value.includes("") && option.value.length > 1) {
        var selectedGroups = this.formGroup.controls["subGroups"].value;
        selectedGroups.splice(selectedGroups.indexOf(""),1);
        this.formGroup.controls["subGroups"].patchValue(selectedGroups);
      }
      if (option.value.includes("Vacio") && option.value.length > 1) {
        var selectedGroups = this.formGroup.controls["subGroups"].value;
        selectedGroups.splice(selectedGroups.indexOf("Vacio"),1);
        this.formGroup.controls["subGroups"].patchValue(selectedGroups);
      }
    }
    this.setDirectAssign();
    this.sendCustomerData();
  }

  allSubGroups(){
    this.formGroup.controls["subGroups"].patchValue([""]);
    this.setDirectAssign();
    this.sendCustomerData();
  }

  noSubGroups(){
    this.formGroup.controls["subGroups"].patchValue(["Vacio"]);
    this.setDirectAssign();
    this.sendCustomerData();
  }

  sendCustomerData(){
    this.selectedClient = {
      selected: true,
      number: this.clientNumber,
      idCustomer: this.otherCustomers.find(x => x.customerName == this.formGroup.controls["client"].value).idCustomer,
      customerName: this.formGroup.controls["client"].value,
      roles: [this.otherCustomers.find(x => x.customerName == this.formGroup.controls["client"].value).roles.find(x => x.roleName == this.formGroup.controls["rol"].value)],
      groups: this.formGroup.controls["groups"].value,
      subGroups: this.formGroup.controls["subGroups"].value,
      identifiers: this.isDirectAssign? this._stringIdentifiers.split(",") : []
    };
    console.log("selectedClient",this.selectedClient);
    

    if(this.getError("rol") == "")
      this.customerData.emit(this.selectedClient);
  }

  setDirectAssign(){
    //verifica que haya un cliente seleccionado
    if (this.formGroup.controls["client"].value != null && this.formGroup.controls["client"].value != "" && this.isDirectAssign) {
      this.filtersList = {Groups: this.formGroup.controls["groups"].value.join(","), SubGroups: this.formGroup.controls["subGroups"].value.join(",")};
      console.log("filtersList",this.filtersList);
      
    }
  }

  public getError(controlName: string): string {
    let error = "";
    const control = this.formGroup.get(controlName);
    if (control?.touched && control?.errors != null) {
      if (control?.errors?.["required"]) error = "Campo Requerido *";
      else error = JSON.stringify(control.errors);
    }
    return error;
  }

  cleanForm(){
    this.formGroup.controls["rol"].patchValue("");
    this.formGroup.controls["identifiers"].patchValue("");
    this.formGroup.controls["groups"].patchValue([""]);
    this.formGroup.controls["subGroups"].patchValue(["Vacio"]);
    this._stringIdentifiers = "";
    this.filtersList = {};
    this.isDirectAssign = false;
  }

  sendEmptyData(){
    //se resetea el formulario y se envía vació al padre si se había seleccionado un cliente antes
    this.selectedClient.selected = false;
    this.selectedClient.number = this.clientNumber;
    this.cleanForm();
    console.log("selectedClient",this.selectedClient);
      
    this.customerData.emit(this.selectedClient);
  }

  DeleteCustomer(){
    this.deleteCustomer.emit(this.clientNumber);
  }

  goToAddRole(){
    window.open('#/roles/add');
  }

  reloadRoles(){
    if (this.subscription_getListRoles) {
      this.subscription_getListRoles.unsubscribe();
    }
    this.subscription_getListRoles = this.roleService.getRoles().subscribe((data) => {
      if (data.isSuccess) {
        this.roles = data.result.map((x) => x.shortName);
      }
    });
  }
}
